import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { logError } from "../lib/logError";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const t = localStorage.getItem("cr_token");
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("cr_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cr_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("cr_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const googleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    localStorage.setItem("cr_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { logError("auth.logout", e); }
    localStorage.removeItem("cr_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, googleSession, logout, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}
